import React, { useEffect, useRef, useState } from "react";
import "./Landing.css";
import { Images } from "../../helpers/Images";
import heroVideo from "../../assets/landing/hero.mp4";
import heroPoster from "../../assets/landing/heroPoster.png";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import MilitaryTechRoundedIcon from "@mui/icons-material/MilitaryTechRounded";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { Drawer } from "@mui/material";
import FirstStagePage from "../../Pages/Registration/FirstStage/FirstStage.page";
import img1 from "../../assets/gallery/image (63).jpg";
import img2 from "../../assets/champion2/i (12).jpg";
import img3 from "../../assets/champion2/i (14).jpg";
import { Typography, Button, Grid } from "@mui/material";
import { Box } from "@mui/system";

const TRACKS = [
  {
    badge: "Youth",
    name: "KidCoder",
    ages: "Ages 5–13",
    desc:
      "Block-based coding, logic puzzles, and creative challenges built for early learners.",
    img: Images.scrBackW,
  },
  {
    badge: "Core",
    name: "Python",
    ages: "Ages 10-17",
    desc:
      "Algorithms, problem solving, and real Python projects judged on code quality and creativity.",
    img: Images.pythonBackW,
  },
  {
    badge: "Build",
    name: "Web",
    ages: "Ages 10-17",
    desc:
      "HTML, CSS, and JavaScript — build a working website to a real-world brief.",
    img: Images.webBackW,
  },
  {
    badge: "Frontier",
    name: "AI",
    ages: "Ages 10-17",
    desc:
      "Train models, fine-tune prompts, and ship an AI-powered project that solves a problem.",
    img: Images.aiBackW,
  },
];

const FAQS = [
  {
    q: "Who can register an academy?",
    a: "Any school, learning center, training academy, or independent trainer working with students aged 5–18 can register. You manage all your students and tracks from one dashboard after signup.",
  },
  {
    q: "How does the Online Round work?",
    a: "The Online Round runs in August. Students compete from your academy or from home in a timed, proctored challenge — judged on accuracy, speed, and creativity. Top scorers fly to Cairo for the in-person Finals in October.",
  },
  {
    q: "How do students qualify for the Cairo Finals?",
    a: "Top-ranking students in each track and age group from the Online Round qualify for the Finals — a hackathon-style live event with workshops, awards, and live judging.",
  },
  {
    q: "What are the four tracks?",
    a: "KidCoder (ages 5-13) for block-based coding, Python (10-17) for algorithms and problem solving, Web (10-17) for HTML/CSS/JavaScript, and AI (10-17) for applied machine learning projects.",
  },
  {
    q: "What experience do students need?",
    a: "None at the entry tracks. KidCoder is built for first-time coders. Python and Web start from real fundamentals, and AI assumes some prior coding background. Every student finds their league.",
  },
  {
    q: "Is the championship really endorsed by STEM.org?",
    a: "Yes. Every finalist receives a STEM.org-endorsed international certificate, and the championship is recognized as a credentialed competitive learning experience.",
  },
];

const scrollToForm = () => {
  const el = document.getElementById("lp-register");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const NAV_LINKS = [
  { id: "tracks", label: "Tracks" },
  { id: "format", label: "Format" },
  { id: "prizes", label: "Prizes" },
  { id: "faq", label: "FAQ" },
];

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const LandingNavBar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const closeDrawer = () => setDrawerOpen(false);

  return (
    <header className="lp-nav">
      <div className="lp-nav-inner">
        <div
          className="lp-nav-brand"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <img src={Images.LogoHor} alt="Code Challenge Championship" />
        </div>
        <nav className="lp-nav-links">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              type="button"
              className="lp-nav-link"
              onClick={() => scrollToId(l.id)}
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          className="lp-btn lp-btn-primary lp-nav-cta"
          onClick={scrollToForm}
        >
          Register Now
        </button>
        <button
          type="button"
          className="lp-nav-burger"
          aria-label="Open menu"
          onClick={() => setDrawerOpen(true)}
        >
          <img src={Images.menu} alt="menu" />
        </button>
      </div>

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={closeDrawer}
        PaperProps={{ className: "lp-root lp-drawer-paper" }}
      >
        <div className="lp-drawer">
          <div className="lp-drawer-head">
            <img
              className="lp-drawer-logo"
              src={Images.LogoHor}
              alt="Code Challenge Championship"
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                closeDrawer();
              }}
            />
            <button
              type="button"
              className="lp-drawer-close"
              aria-label="Close menu"
              onClick={closeDrawer}
            >
              <CloseRoundedIcon />
            </button>
          </div>
          <nav className="lp-drawer-links">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                type="button"
                className="lp-drawer-link"
                onClick={() => {
                  closeDrawer();
                  setTimeout(() => scrollToId(l.id), 250);
                }}
              >
                {l.label}
              </button>
            ))}
          </nav>
          <button
            type="button"
            className="lp-btn lp-btn-primary lp-btn-lg lp-drawer-cta"
            onClick={() => {
              closeDrawer();
              setTimeout(scrollToForm, 250);
            }}
          >
            Register Now
          </button>
        </div>
      </Drawer>
    </header>
  );
};

const HeroVideo = () => {
  const videoRef = useRef(null);
  const [hasStarted, setHasStarted] = useState(false);

  const handlePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    v.play()
      .then(() => setHasStarted(true))
      .catch(() => setHasStarted(true));
  };

  return (
    <div className="lp-hero-image">
      <video
        ref={videoRef}
        src={heroVideo}
        poster={heroPoster}
        playsInline
        preload="metadata"
        controls={hasStarted}
        onPlay={() => setHasStarted(true)}
        onPause={(e) => {
          if (e.currentTarget.currentTime === 0) setHasStarted(false);
        }}
      />
      {!hasStarted && (
        <button
          type="button"
          className="lp-video-overlay-btn"
          aria-label="Play video"
          onClick={handlePlay}
        >
          <span className="lp-video-play-circle">
            <PlayArrowRoundedIcon style={{ fontSize: 48 }} />
          </span>
        </button>
      )}
    </div>
  );
};

const Hero = () => (
  <section className="lp-hero">
    <div className="lp-section">
      <div className="lp-hero-grid">
        <div>
          <span className="lp-urgency-pill">
            <span className="lp-urgency-dot" />
            Registration closing soon · Online Round starts August
          </span>
          <h1 className="lp-h1" style={{ marginTop: 18 }}>
            The Arab world's <span className="lp-red">#1 coding</span> &amp; AI championship for students 5–18.
          </h1>
          <p className="lp-sub" style={{ marginTop: 18, maxWidth: 540 }}>
            Code Challenge Championship brings together thousands of young coders from 7+ Arab
            countries. Compete for 250,000 EGP in prizes — endorsed by STEM.org.
          </p>
          <div className="lp-hero-cta">
            <button className="lp-btn lp-btn-primary lp-btn-lg" onClick={scrollToForm}>
              <BoltRoundedIcon style={{ fontSize: 18 }} />
              Register Now
            </button>
          </div>
          <div className="lp-hero-stats">
            <div>
              <div className="lp-stat-num">
                <span className="lp-red">250K</span>
              </div>
              <div className="lp-stat-label">EGP prize pool</div>
            </div>
            <div>
              <div className="lp-stat-num">7+</div>
              <div className="lp-stat-label">Arab countries</div>
            </div>
            <div>
              <div className="lp-stat-num">4</div>
              <div className="lp-stat-label">Competition tracks</div>
            </div>
          </div>
        </div>

        <div>
          <HeroVideo />
        </div>
      </div>
    </div>
  </section>
);

const Tracks = () => (
  <section className="lp-section" id="tracks">
    <div className="lp-tracks-head">
      <span className="lp-eyebrow">4 Tracks</span>
      <h2 className="lp-h2" style={{ marginTop: 10 }}>
        A track for every age, every skill level.
      </h2>
      <p className="lp-sub" style={{ marginTop: 12 }}>
        From first lines of code to shipping AI projects — every student finds their league.
      </p>
      <div className="lp-divider" />
    </div>
    <div className="lp-tracks-grid">
      {TRACKS.map((t) => (
        <div className="lp-track" key={t.name}>
          <div className="lp-track-img-crop">
            <img className="lp-track-img" src={t.img} alt={t.name} />
          </div>
          <div className="lp-track-body">
            <div className="lp-track-badge">{t.badge}</div>
            <div className="lp-track-name">
              <span>{t.name}</span>
              <span className="lp-track-ages">{t.ages}</span>
            </div>
            <p className="lp-track-desc">{t.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);

const Format = () => (
  <section className="lp-format" id="format">
    <div className="lp-section">
      <div className="lp-format-grid">
        <div>
          <span className="lp-eyebrow">The Format</span>
          <h2 className="lp-h2" style={{ marginTop: 10 }}>
            Two rounds. One champion per track.
          </h2>
          <p className="lp-sub" style={{ marginTop: 14, maxWidth: 460 }}>
            Students compete online from anywhere in the Arab world. Top scorers fly to
            Cairo for the in-person Finals — live judging, awards, and the spotlight.
          </p>
        </div>
        <div>
          <div className="lp-rounds">
            <div className="lp-round">
              <div className="lp-round-num">01</div>
              <div className="lp-round-month">August 2026</div>
              <div className="lp-round-title">Online Round</div>
              <div className="lp-round-desc">
                A timed, proctored challenge run from your academy or home. Judged on
                accuracy, speed, and creativity.
              </div>
              <div className="lp-round-tag">Open to all 7+ countries</div>
            </div>
            <div className="lp-round lp-round-finals">
              <div className="lp-round-num">02</div>
              <div className="lp-round-month">October 2026</div>
              <div className="lp-round-title">Finals — Cairo</div>
              <div className="lp-round-desc">
                Top qualifiers join a two-day live event with workshops, a hackathon-style
                final, and the awards ceremony.
              </div>
              <div className="lp-round-tag">In-person · Live judging</div>
            </div>
          </div>
          <div className="lp-banner">
            <BoltRoundedIcon style={{ color: "var(--lp-red)" }} />
            <div>
              <b>Registration is open now</b> — academies that register early get priority
              placement and training resources.
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const Prizes = () => (
  <section className="lp-section" id="prizes">
    <div className="lp-prize-grid">
      <div>
        <span className="lp-eyebrow">Prize Pool</span>
        <div className="lp-prize-num" style={{ marginTop: 12 }}>
          250,000 EGP
        </div>
        <h2 className="lp-h2" style={{ marginTop: 8 }}>
          Cash, scholarships &amp; gear.
        </h2>
        <p className="lp-sub" style={{ marginTop: 14, maxWidth: 480 }}>
          Distributed across the four tracks. Plus internationally-recognized certificates
          endorsed by STEM.org for every finalist.
        </p>
        <ul className="lp-prize-list">
          <li className="lp-prize-item">
            <span className="lp-prize-icon"><EmojiEventsRoundedIcon /></span>
            <div>
              <div className="lp-prize-title">Champion per track</div>
              <div className="lp-prize-sub">Cash prize, trophy, and a STEM.org-endorsed certificate.</div>
            </div>
          </li>
          <li className="lp-prize-item">
            <span className="lp-prize-icon"><MilitaryTechRoundedIcon /></span>
            <div>
              <div className="lp-prize-title">Runner-up &amp; 3rd place</div>
              <div className="lp-prize-sub">Cash awards, medals, and partner gear from Rapoo, Fantech &amp; Maono.</div>
            </div>
          </li>
          <li className="lp-prize-item">
            <span className="lp-prize-icon"><WorkspacePremiumRoundedIcon /></span>
            <div>
              <div className="lp-prize-title">Best Academy Award</div>
              <div className="lp-prize-sub">Special recognition for the school with the strongest cohort.</div>
            </div>
          </li>
        </ul>
      </div>
      <div className="lp-photo-collage">
        <div className="lp-photo">
          <img src={img3} alt="" />
          <div className="lp-photo-tag">Stage · Awards</div>
        </div>
        <div className="lp-photo">
          <img src={img1} alt="" />
          <div className="lp-photo-tag">Students competing</div>
        </div>
        <div className="lp-photo">
          <img src={img2} alt="" />
          <div className="lp-photo-tag">Winners</div>
        </div>
      </div>
    </div>
  </section>
);

const FAQ = () => (
  <section className="lp-faq" id="faq">
    <div className="lp-section">
      <div className="lp-faq-head">
        <span className="lp-eyebrow">FAQ</span>
        <h2 className="lp-h2" style={{ marginTop: 10 }}>
          Everything academies &amp; trainers ask.
        </h2>
        <div className="lp-divider" />
      </div>
      <div className="lp-faq-list">
        {FAQS.map((f, i) => (
          <details className="lp-faq-item" key={i}>
            <summary className="lp-faq-summary">
              {f.q}
              <span className="lp-faq-icon">+</span>
            </summary>
            <div className="lp-faq-body">{f.a}</div>
          </details>
        ))}
      </div>
    </div>
  </section>
);


const Sponsers = () => (
     <Box
    sx={{
      width: "100%",
      padding: {
        xs: "50px 20px",
        sm: "50px 60px",
        lg: "70px 120px",
      },
      backgroundColor: "secondary.main",
      maxWidth: "1500px",
      margin: "auto",
    }}
  >
    <Typography
      variant={"h2"}
      sx={{
        textAlign: "center",
        fontSize: "35px",
        fontWeight: "500",
        color: "primary.darker",
      }}
    >
      Code Challenge Sponsors
    </Typography>
    <Box
      sx={{
        height: "3px",
        width: "150px",
        backgroundColor: "primary.light",
        margin: "10px auto",
      }}
    />
    <Grid
      container
      spacing={{ xs: 0, sm: 3 }}
      sx={{ justifyContent: "center", marginTop: "20px" }}
    >
      <Grid
        item
        xs={6}
        sm={3}
        md={3}
        sx={{ display: "flex", order: { xs: "2", sm: "1" } }}
      >
        <img
          src={Images.sponsor6}
          alt=""
          loading="lazy"
          style={{ height: "45px", margin: "auto", maxWidth: "100%" }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        md={3}
        lg={2}
        sx={{ display: "flex", order: { xs: "1", sm: "2" }, margin: "5px" }}
      >
        <img
          src={Images.sponsor1}
          alt=""
          loading="lazy"
          style={{
            height: "70px",
            margin: "auto",
            maxWidth: "100%",
            objectFit: "cover",
          }}
        />
      </Grid>
      <Grid
        item
        xs={6}
        sm={3}
        md={3}
        sx={{ display: "flex", order: { xs: "3", sm: "3" } }}
      >
        <img
          src={Images.sponsor11}
          alt=""
          loading="lazy"
          style={{ height: "50px", margin: "auto", maxWidth: "100%" }}
        />
      </Grid>
    </Grid>
    <Grid
      container
      spacing={{ xs: 0, sm: 6 }}
      sx={{
        justifyContent: "center",
        marginTop: { xs: "10px", sm: "0px" },
        maxWidth: "100%",
      }}
    >
      <Grid item xs={6} sm={3} md={3} lg={3} sx={{ display: "flex" }}>
        <img
          src={Images.sponsor8}
          alt=""
          loading="lazy"
          style={{ height: "40px", margin: "auto", maxWidth: "100%" }}
        />
      </Grid>
      <Grid item xs={6} sm={3} md={3} lg={3} sx={{ display: "flex" }}>
        <img
          src={Images.sponsor4}
          alt=""
          loading="lazy"
          style={{ height: "30px", margin: "auto", maxWidth: "100%" }}
        />
      </Grid>
      <Grid item xs={6} sm={3} md={3} lg={3} sx={{ display: "flex" }}>
        <img
          src={Images.sponsor10}
          alt=""
          loading="lazy"
          style={{ height: "40px", margin: "auto", maxWidth: "100%" }}
        />
      </Grid>
      <Grid item xs={6} sm={3} md={3} lg={3} sx={{ display: "flex" }}>
        <img
          src={Images.sponsor9}
          alt=""
          loading="lazy"
          style={{ height: "40px", margin: "auto", maxWidth: "100%" }}
        />
      </Grid>
    </Grid>
  </Box>
);

const LandingTemplate = () => {
  useEffect(() => {
    document.body.style.background = "#fff";
    return () => {
      document.body.style.background = "";
    };
  }, []);
  
  return (
    <div className="lp-root">
      <LandingNavBar />
      <Hero />
      <Sponsers/>
      <Tracks />
      <Format />
      <Prizes />
      <FAQ />
      <div id="lp-register">
        <FirstStagePage />
      </div>
    </div>
  );
};

export default LandingTemplate;
